export function leadZero(n, targetLength) {
    if (targetLength === void 0) { targetLength = 2; }
    var output = n + '';
    while (output.length < targetLength) {
        output = '0' + output;
    }
    return output;
}
export function absFloor(num) {
    if (num < 0) {
        // -0 -> 0
        return Math.ceil(num) || 0;
    }
    else {
        return Math.floor(num);
    }
}
export function extend(obj1, obj2) {
    var result = {};
    for (var key in obj1) {
        result[key] = obj1[key];
    }
    for (var key in obj2) {
        result[key] = obj2[key];
    }
    return result;
}
export function tokensRx(obj) {
    var keys = [];
    for (var key in obj) {
        keys.push(key);
    }
    keys.sort(function (a, b) { return b.length - a.length; });
    return new RegExp(keys.join('|') + '|\\[[^[]*\\]|.', 'g');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-date/esm/src/utils/utils.js
// module id = null
// module chunks = 